import {
  Wrench, Hammer, Scale, Stethoscope, Car, UtensilsCrossed,
  Scissors, Dumbbell, Home, Briefcase, Store, ShoppingCart,
} from "lucide-react";
import { Reveal } from "./Reveal";

const INDUSTRIES = [
  { icon: Wrench, label: "Home Services" },
  { icon: Hammer, label: "Contractors" },
  { icon: Scale, label: "Attorneys" },
  { icon: Stethoscope, label: "Medical / Dental" },
  { icon: Car, label: "Automotive" },
  { icon: UtensilsCrossed, label: "Restaurants" },
  { icon: Scissors, label: "Beauty" },
  { icon: Dumbbell, label: "Fitness" },
  { icon: Home, label: "Real Estate" },
  { icon: Briefcase, label: "Professional Services" },
  { icon: Store, label: "Local Businesses" },
  { icon: ShoppingCart, label: "E-Commerce" },
];

export const Industries = () => (
  <section className="relative py-12 sm:py-16">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <h2 className="max-w-4xl font-display text-4xl font-extrabold leading-[0.95] tracking-tighter text-white sm:text-5xl lg:text-6xl">
          Built For Businesses That Need A{" "}
          <span className="text-purple-500">Steady Flow Of Customers.</span>
        </h2>
      </Reveal>

      <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {INDUSTRIES.map((ind, i) => (
          <Reveal key={ind.label} delay={0.03 * i}>
            <div
              data-testid={`industry-${ind.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group flex items-center gap-3.5 rounded-2xl border border-[#272732] bg-[#121217] px-5 py-5 transition-all duration-300 hover:-translate-y-0.5 hover:border-purple-500/50"
            >
              <ind.icon className="h-5 w-5 shrink-0 text-purple-400 transition-transform duration-300 group-hover:scale-110" />
              <span className="text-sm font-bold text-white sm:text-base">{ind.label}</span>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <p className="mt-8 text-sm text-zinc-500">
          …and any business that wins when the right customer finds them first.
        </p>
      </Reveal>
    </div>
  </section>
);
